import { render } from "./ExpiredModal.vue?vue&type=template&id=43fa4911"
import script from "./ExpiredModal.vue?vue&type=script&lang=js"
export * from "./ExpiredModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/jeronimo/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__